<template>
<div>
    <Breadcrumb :title="'Custom Memo'"></Breadcrumb>
    <div>
        <BaseSearchBar :config="search" @keyupSearch="filterGrid"></BaseSearchBar>
    </div>
    <div class="btnDiv">
        <BaseToolBar :config="ToolbarConfig" @buttonClicked="toolbarOnClick"></BaseToolBar>
    </div>
    <div>
        <MemoForm :ref="'MemoForm'" :MemoInfo="MemoJSON" :MemoModalLabel="modalConfig"></MemoForm>
    </div>
    <div>
        <BaseGrid :config="GridConfig" :mode="'editform'" @EditItem="EditMemo" @DeleteItem="DeleteMemo"></BaseGrid>
    </div>
</div>
</template>

<script>
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import { ToolbarConfig, GridConfig } from "./MemoConfig.js";
import BaseModelMemo from "@/models/BaseModelMemo.js";
import MemoForm from "@/components/forms/MemoForm.vue";
import funcUtil from "@/services/funcUtil.js";
import toolbarUtility from "@/services/toolbarUtility.js";
import { mapGetters, mapActions } from 'vuex';

export default {
    name: "Memo",
    components: {
        Breadcrumb,
        BaseGrid,
        MemoForm,
        BaseToolBar,
        BaseSearchBar
    },
    mixins: [funcUtil, toolbarUtility],
    data: function () {
        return {
            GridConfig: GridConfig,
            modalConfig: {
                modalName: "",
                modalAddorEdit: ""
            },
            ToolbarConfig: ToolbarConfig,
            search: {
                SearchData: "",
            },
            MemoJSON: {},
            MemoMasterData: {},
            MemoGridId:"MemoGrid"
        };
    },
    computed: {
        ...mapGetters("getModule", ["withFilter"])
    },
    methods: {
        ...mapActions("postModule",['DeleteItem']),
        EditMemo(e) {
            let self = this;
            e.preventDefault();
            this.modalConfig.modalName = "Edit Memo";
            this.modalConfig.modalAddorEdit = "edit";
            var gview = window.$("#"+self.MemoGridId).data("kendoGrid");
            var dataItem = JSON.parse(JSON.stringify(gview.dataItem(window.$(e.currentTarget).closest("tr"))));
            this.$refs.MemoForm.pageErrors = [];
            self.MemoJSON = dataItem;
            this.$refs.MemoForm.DisableField(self.MemoJSON);
            this.$refs.MemoForm.bDisableFields=false;
            window.$("#BaseModal").modal("toggle");
        },
        DeleteMemo(e){
            let self=this;
            e.preventDefault();
            const message = "Are you sure you want to delete this record?";
            this._ConfirmationPopup(message, "DELETE").then(result => {
                if (result.value) {
                //let loader = this.$loading.show();
                 this._APICrudPopup("APICrudpopup");
                let gview = window.$("#"+self.MemoGridId).data("kendoGrid");
                let dataItem = gview.dataItem(
                    window.$(e.currentTarget).closest("tr")
                );
                let deleteData = { Id: dataItem.Id };
                let ItemsToBeDeleted = { list:GridConfig, payload:deleteData }
                this.DeleteItem(ItemsToBeDeleted).then(response => {
                    $("#"+self.MemoGridId).data().kendoGrid.dataSource.read();
                    this._AlertPopup("Deleted successfully!","success");
                }).catch(error=>{
                    this._AlertPopup("Some Error Occurred!","info");
                }).finally(()=>{
                    //loader.hide();
                })
                }
            });
        },
        filterGrid(e) {
            let self = this;
            let currentMasterdata = this.MemoMasterData;
            let filteredData = this._filterGrid(
                this.MemoMasterData,
                this.search.SearchData
            );
            //Filter by a column
            $("#"+self.MemoGridId).data("kendoGrid").dataSource.data(filteredData);
            this.UpdateMemoMasterData(true, currentMasterdata);    
        },
        toolbarOnClick(e) {
            e.preventDefault();
            switch (e.id) {
                case "btnAddMemo":
                    this.AddMemo();
                    window.$("#BaseModal").modal("toggle");
                    break;
                default:
                   break; 
            }
            this._baseToolBarEvents(this.MemoGridId, ...arguments);
        },
        AddMemo: function () {
            this.modalConfig.modalName = "Add Memo";
            this.modalConfig.modalAddorEdit = "add";
            let MemoAddJSON = {
                Id: null,
                TaxPeriod: "",
                MemoType: "",
                ProgramId: null,
                ProgramTitle:"",
                InvestmentId: null,
                InvestmentTitle:"",
                Location:"",
                MemoText:""
            };
            this.$refs.MemoForm.pageErrors = [];
            this.$refs.MemoForm.bDisableFields=false;
            this.$refs.MemoForm.bDisableProgram=true;
            this.$refs.MemoForm.bDisableInvestment=true;
            this.$refs.MemoForm.bDisableLocation=true;
            this.MemoJSON = MemoAddJSON;
        },
        UpdateMemoMasterData: function(fromFilter, filterMasterData) {
            let self=this;
            if (fromFilter == true) {
                self.MemoMasterData = filterMasterData;
            } else {
                self.MemoMasterData = JSON.parse(JSON.stringify($("#"+self.MemoGridId).data().kendoGrid.dataSource.data()));
            }
        },
    },
    mounted() {
        let self=this;
        self._loadGridSettings(self.MemoGridId);

        //bind databound event to grid
        // self.grid.bind("dataBound", self.UpdateIssuanceMasterData);
        let grid = $("#"+self.MemoGridId).data("kendoGrid");
        grid.bind("dataBound", self.UpdateMemoMasterData);
        grid.dataSource.fetch();
    },
}
</script>

<style>
</style>
